import React from 'react';
import {
  Paper, Typography, makeStyles, Theme, createStyles, useTheme,
} from '@material-ui/core';
import { useContextValue } from '../../../context/AppContextProvider';
import StatsTable from './statsTable';
import statsExtractor from '../../../utils/statsDataUtils';
import Objectifs from './Objectifs';
import OnBording from './OnBording';
import QuoteBox from './quoteBox';
import './index.css';

const useStyles = makeStyles((theme: Theme) => createStyles({
  b: {
    display: 'flex',
    flexDirection: 'column',
    width: '30vw',
    flexGrow: 1,
    overflow: 'auto',
    minWidth: '380px',
    backgroundColor: theme.palette.background.paper,
  },
}));

const StatesBar = () => {
  const [{ tasks }] = useContextValue();
  const statsData = statsExtractor(tasks);

  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.b}>
      <QuoteBox />
      <OnBording />

      <Objectifs />

      <Paper className="container">
        <Paper elevation={0} square className="header-card">
          <Typography variant="h6" color="textSecondary">Statistics</Typography>
        </Paper>
        <StatsTable data={statsData} />
      </Paper>


    </div>
  );
};

export default StatesBar;
